export const COMPANY_BUSINESS_TYPE = 'ooo';
export const ENTREPRENEUR_BUSINESS_TYPE = 'ip';

export function resolveBusinessType(company = {}) {
  const businessType = String(company.businessType || '').trim().toLowerCase();

  if (businessType === ENTREPRENEUR_BUSINESS_TYPE) return ENTREPRENEUR_BUSINESS_TYPE;
  if (businessType === COMPANY_BUSINESS_TYPE) return COMPANY_BUSINESS_TYPE;

  return String(company.registryKind || '').trim().toUpperCase() === 'EGRIP'
    ? ENTREPRENEUR_BUSINESS_TYPE
    : COMPANY_BUSINESS_TYPE;
}
